var sessionService = require('sessionService'),
    loader = require('loader');

//Folder dropdown functionality
var sessions = (function() {

    var $sessionList = $('.session-list'),
        $clickedLink = null;


    var deleteClick = function() {
        $('.delete-session').on('click', function(e) {
            e.preventDefault();
            $clickedLink = $(this);

            $('window').modal({
                title: "Are you sure you want to delete this session?",
                content: "Once deleted, you won't be able to get this session back.",
                confirmText: 'Delete',
                complete: confirmDelete
            });
        });
    };


    var confirmDelete = function() {
        $('window').showLoader();
        var sessionID = $clickedLink.closest('.card-session').attr('data-id');
        deleteSessionService(sessionID, deleteFolder);
    };


    var deleteFolder = function(response) {
        if (response.status === 'success') {
            $('window').notification({ title: response.message });
            $('.folder.active').addClass('deleted');
            closeOverlay();
        } else {
            $('window').notification({ title: response.message, error: true });
        }
    };


    var init = function() {
        if ($sessionList.length) {
            deleteClick();
        }
    };


    return {
        init: init
    };

})();
sessions.init();



// WEBPACK FOOTER //
// ./library/js/modules/sessions.js